// Replaces LOCATION_CHANGE from connected-react-router.
// Dispatched by <LocationChangeDispatcher /> in App.tsx on every navigation.
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
